import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Icon/typography-led tool or department card (no stock photo thumbnails).
 */
const ToolCard = ({
  title,
  description,
  icon: Icon,
  to,
  badge = 'Active',
  badgeTone = 'ok',
  disabled = false,
  disabledLabel = 'No access',
  meta,
  onClick,
}) => {
  const toneClass =
    badgeTone === 'warn'
      ? 'nx-chip-warn'
      : badgeTone === 'bad'
        ? 'nx-chip-bad'
        : badgeTone === 'info'
          ? 'nx-chip-info'
          : 'nx-chip-ok'

  const body = (
    <article
      className={`nx-panel group relative flex h-full flex-col gap-4 p-5 transition ${
        disabled
          ? 'opacity-60 cursor-not-allowed'
          : 'hover:border-signal/40 hover:shadow-[0_0_0_1px_rgba(66,203,229,0.2)]'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-rule bg-surface text-signal">
          {Icon ? <Icon className="h-5 w-5" aria-hidden /> : <span className="font-mono text-sm">NX</span>}
        </div>
        <span className={toneClass}>{disabled ? disabledLabel : badge}</span>
      </div>
      <div>
        <h3 className="font-display text-xl font-semibold tracking-wide text-paper">{title}</h3>
        {description && <p className="mt-1.5 text-sm leading-relaxed text-muted">{description}</p>}
      </div>
      {meta && <div className="mt-auto pt-1 text-xs text-muted">{meta}</div>}
      {!disabled && (
        <div className="mt-auto flex items-center gap-2 pt-1 font-mono text-[11px] uppercase tracking-wider text-signal opacity-80 group-hover:opacity-100">
          Open workspace
          <span aria-hidden>→</span>
        </div>
      )}
    </article>
  )

  if (disabled || !to) {
    return (
      <div
        role={onClick && !disabled ? 'button' : undefined}
        onClick={disabled ? undefined : onClick}
        className="block h-full"
      >
        {body}
      </div>
    )
  }

  return (
    <Link to={to} className="block h-full focus-visible:rounded-xl">
      {body}
    </Link>
  )
}

export default ToolCard
